/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Food Security Exchange API
 * REST API for the FSE platform. Endpoints by BRS module (PLAN.md §5).
 * OpenAPI spec version: 0.0.1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  CreateTraceEventDto,
  PublicProvenanceDto,
  TraceEventDto,
  TraceEventPhotoDto,
  TraceEventPhotoListDto,
  UploadTraceEventPhotoDto
} from '.././models';

import { fseAxios } from '../../client';




/**
 * Builds a deterministic canonical-JSON envelope, keccak256-hashes it into content_hash, persists the event + enqueues a chain_anchor outbox row (anchor is deferred). For subjectKind=batch the caller's cooperative must own the batch (else 404; admin bypasses). Replaying an identical event is idempotent (deduped on content_hash). Returns anchorStatus="pending" until the chain worker back-fills.
 * @summary Record a provenance trace event
 */
export const traceControllerRecordEvent = (
    createTraceEventDto: CreateTraceEventDto,
 signal?: AbortSignal
) => {
      
      
      return fseAxios<TraceEventDto>(
      {url: `/trace/events`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createTraceEventDto, signal
    },
      );
    }
  


export const getTraceControllerRecordEventMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof traceControllerRecordEvent>>, TError,{data: CreateTraceEventDto}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof traceControllerRecordEvent>>, TError,{data: CreateTraceEventDto}, TContext> => {

const mutationKey = ['traceControllerRecordEvent'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof traceControllerRecordEvent>>, {data: CreateTraceEventDto}> = (props) => {
          const {data} = props ?? {};

          return  traceControllerRecordEvent(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type TraceControllerRecordEventMutationResult = NonNullable<Awaited<ReturnType<typeof traceControllerRecordEvent>>>
    export type TraceControllerRecordEventMutationBody = CreateTraceEventDto
    export type TraceControllerRecordEventMutationError = unknown

    /**
 * @summary Record a provenance trace event
 */
export const useTraceControllerRecordEvent = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof traceControllerRecordEvent>>, TError,{data: CreateTraceEventDto}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof traceControllerRecordEvent>>,
        TError,
        {data: CreateTraceEventDto},
        TContext
      > => {

      const mutationOptions = getTraceControllerRecordEventMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * One image file in the multipart field "file" (image/* only, max 5 MB). The bytes are proxied to internal MinIO; this returns the photo metadata. The event's subject must be owned by the caller (else 404). 400 if not an image or over 5 MB.
 * @summary Upload a photo to a trace event (multipart/form-data)
 */
export const traceControllerUploadPhoto = (
    id: string,
    uploadTraceEventPhotoDto: UploadTraceEventPhotoDto,
 signal?: AbortSignal
) => {
      
      const formData = new FormData();
formData.append(`file`, uploadTraceEventPhotoDto.file)

      return fseAxios<TraceEventPhotoDto>(
      {url: `/trace/events/${id}/photos`, method: 'POST',
      headers: {'Content-Type': 'multipart/form-data', },
       data: formData, signal
    },
      );
    }
  


export const getTraceControllerUploadPhotoMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof traceControllerUploadPhoto>>, TError,{id: string;data: UploadTraceEventPhotoDto}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof traceControllerUploadPhoto>>, TError,{id: string;data: UploadTraceEventPhotoDto}, TContext> => {

const mutationKey = ['traceControllerUploadPhoto'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof traceControllerUploadPhoto>>, {id: string;data: UploadTraceEventPhotoDto}> = (props) => {
          const {id,data} = props ?? {};

          return  traceControllerUploadPhoto(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type TraceControllerUploadPhotoMutationResult = NonNullable<Awaited<ReturnType<typeof traceControllerUploadPhoto>>>
    export type TraceControllerUploadPhotoMutationBody = UploadTraceEventPhotoDto
    export type TraceControllerUploadPhotoMutationError = unknown

    /**
 * @summary Upload a photo to a trace event (multipart/form-data)
 */
export const useTraceControllerUploadPhoto = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof traceControllerUploadPhoto>>, TError,{id: string;data: UploadTraceEventPhotoDto}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof traceControllerUploadPhoto>>,
        TError,
        {id: string;data: UploadTraceEventPhotoDto},
        TContext
      > => {

      const mutationOptions = getTraceControllerUploadPhotoMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Metadata only — fetch the bytes via GET /trace/events/:id/photos/:photoId. 404 if the event's subject is not owned by the caller.
 * @summary List photo metadata for a trace event (newest first)
 */
export const traceControllerListPhotos = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return fseAxios<TraceEventPhotoListDto>(
      {url: `/trace/events/${id}/photos`, method: 'GET', signal
    },
      );
    }
  



export const getTraceControllerListPhotosQueryKey = (id?: string,) => {
    return [
    `/trace/events/${id}/photos`
    ] as const;
    }

    
export const getTraceControllerListPhotosQueryOptions = <TData = Awaited<ReturnType<typeof traceControllerListPhotos>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof traceControllerListPhotos>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTraceControllerListPhotosQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof traceControllerListPhotos>>> = ({ signal }) => traceControllerListPhotos(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof traceControllerListPhotos>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type TraceControllerListPhotosQueryResult = NonNullable<Awaited<ReturnType<typeof traceControllerListPhotos>>>
export type TraceControllerListPhotosQueryError = unknown


export function useTraceControllerListPhotos<TData = Awaited<ReturnType<typeof traceControllerListPhotos>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof traceControllerListPhotos>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof traceControllerListPhotos>>,
          TError,
          Awaited<ReturnType<typeof traceControllerListPhotos>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useTraceControllerListPhotos<TData = Awaited<ReturnType<typeof traceControllerListPhotos>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof traceControllerListPhotos>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof traceControllerListPhotos>>,
          TError,
          Awaited<ReturnType<typeof traceControllerListPhotos>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useTraceControllerListPhotos<TData = Awaited<ReturnType<typeof traceControllerListPhotos>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof traceControllerListPhotos>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary List photo metadata for a trace event (newest first)
 */

export function useTraceControllerListPhotos<TData = Awaited<ReturnType<typeof traceControllerListPhotos>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof traceControllerListPhotos>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getTraceControllerListPhotosQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Proxies the image bytes from internal MinIO with the stored Content-Type. 404 if the photo is not on an event whose subject is owned by the caller.
 * @summary Stream a single trace-event photo (image bytes)
 */
export const traceControllerGetPhoto = (
    id: string,
    photoId: string,
 signal?: AbortSignal
) => {
      
      
      return fseAxios<Blob>(
      {url: `/trace/events/${id}/photos/${photoId}`, method: 'GET',
        responseType: 'blob', signal
    },
      );
    }
  



export const getTraceControllerGetPhotoQueryKey = (id?: string,
    photoId?: string,) => {
    return [
    `/trace/events/${id}/photos/${photoId}`
    ] as const;
    }

    
export const getTraceControllerGetPhotoQueryOptions = <TData = Awaited<ReturnType<typeof traceControllerGetPhoto>>, TError = unknown>(id: string,
    photoId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof traceControllerGetPhoto>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTraceControllerGetPhotoQueryKey(id,photoId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof traceControllerGetPhoto>>> = ({ signal }) => traceControllerGetPhoto(id,photoId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id && photoId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof traceControllerGetPhoto>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type TraceControllerGetPhotoQueryResult = NonNullable<Awaited<ReturnType<typeof traceControllerGetPhoto>>>
export type TraceControllerGetPhotoQueryError = unknown


export function useTraceControllerGetPhoto<TData = Awaited<ReturnType<typeof traceControllerGetPhoto>>, TError = unknown>(
 id: string,
    photoId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof traceControllerGetPhoto>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof traceControllerGetPhoto>>,
          TError,
          Awaited<ReturnType<typeof traceControllerGetPhoto>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useTraceControllerGetPhoto<TData = Awaited<ReturnType<typeof traceControllerGetPhoto>>, TError = unknown>(
 id: string,
    photoId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof traceControllerGetPhoto>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof traceControllerGetPhoto>>,
          TError,
          Awaited<ReturnType<typeof traceControllerGetPhoto>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useTraceControllerGetPhoto<TData = Awaited<ReturnType<typeof traceControllerGetPhoto>>, TError = unknown>(
 id: string,
    photoId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof traceControllerGetPhoto>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Stream a single trace-event photo (image bytes)
 */

export function useTraceControllerGetPhoto<TData = Awaited<ReturnType<typeof traceControllerGetPhoto>>, TError = unknown>(
 id: string,
    photoId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof traceControllerGetPhoto>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getTraceControllerGetPhotoQueryOptions(id,photoId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Unauthenticated. Returns the subject's trace events (occurred_at ASC) with each payload whitelist-redacted (no PII, never actorUserId) and a per-event contentHashValid flag (the stored payload is re-hashed and compared to the stored content_hash — tamper-evidence). Top-level verification summarises allValid + anchored/pending counts. 400 if kind is not batch|contribution|transaction or id is not a uuid.
 * @summary PUBLIC: provenance trail + cryptographic verification for a subject
 */
export const tracePublicControllerGetProvenance = (
    kind: string,
    id: string,
 signal?: AbortSignal
) => {
      
      
      return fseAxios<PublicProvenanceDto>(
      {url: `/trace/subject/${kind}/${id}`, method: 'GET', signal
    },
      );
    }
  



export const getTracePublicControllerGetProvenanceQueryKey = (kind?: string,
    id?: string,) => {
    return [
    `/trace/subject/${kind}/${id}`
    ] as const;
    }

    
export const getTracePublicControllerGetProvenanceQueryOptions = <TData = Awaited<ReturnType<typeof tracePublicControllerGetProvenance>>, TError = unknown>(kind: string,
    id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof tracePublicControllerGetProvenance>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTracePublicControllerGetProvenanceQueryKey(kind,id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof tracePublicControllerGetProvenance>>> = ({ signal }) => tracePublicControllerGetProvenance(kind,id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(kind && id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof tracePublicControllerGetProvenance>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type TracePublicControllerGetProvenanceQueryResult = NonNullable<Awaited<ReturnType<typeof tracePublicControllerGetProvenance>>>
export type TracePublicControllerGetProvenanceQueryError = unknown


export function useTracePublicControllerGetProvenance<TData = Awaited<ReturnType<typeof tracePublicControllerGetProvenance>>, TError = unknown>(
 kind: string,
    id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof tracePublicControllerGetProvenance>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof tracePublicControllerGetProvenance>>,
          TError,
          Awaited<ReturnType<typeof tracePublicControllerGetProvenance>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useTracePublicControllerGetProvenance<TData = Awaited<ReturnType<typeof tracePublicControllerGetProvenance>>, TError = unknown>(
 kind: string,
    id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof tracePublicControllerGetProvenance>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof tracePublicControllerGetProvenance>>,
          TError,
          Awaited<ReturnType<typeof tracePublicControllerGetProvenance>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useTracePublicControllerGetProvenance<TData = Awaited<ReturnType<typeof tracePublicControllerGetProvenance>>, TError = unknown>(
 kind: string,
    id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof tracePublicControllerGetProvenance>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary PUBLIC: provenance trail + cryptographic verification for a subject
 */

export function useTracePublicControllerGetProvenance<TData = Awaited<ReturnType<typeof tracePublicControllerGetProvenance>>, TError = unknown>(
 kind: string,
    id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof tracePublicControllerGetProvenance>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getTracePublicControllerGetProvenanceQueryOptions(kind,id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




